import io from "socket.io-client";

const ENDPOINT = "https://api.analizesportive.ro";
const socket = io(ENDPOINT); // replace with your server URL

export default socket;
